import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";

import App from './App/index';
import config from './config';

import * as serviceWorker from './serviceWorker';

import { store, persistor } from './storeConfig';

const app = 
(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter basename={config.basename}>
				<App />
			</BrowserRouter>
		</PersistGate>	
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
